import React, {useState} from "react";
import TaskMainContainer from "./TaskMainContainer";
import '../styles/logicWheel2.css';

import dragImg11 from "../images/arrangeByColumns/LogicWedge5_1_1.png";
import dragImg12 from "../images/arrangeByColumns/LogicWedge5_1_2.png";
import dragImg13 from "../images/arrangeByColumns/LogicWedge5_1_3.png";

import dragImg23 from "../images/arrangeByColumns/LogicWedge5_2_1.png";
import dragImg21 from "../images/arrangeByColumns/LogicWedge5_2_2.png";
import dragImg22 from "../images/arrangeByColumns/LogicWedge5_2_3.png";

import dragImg33 from "../images/arrangeByColumns/LogicWedge5_3_1.png";
import dragImg31 from "../images/arrangeByColumns/LogicWedge5_3_2.png";
import dragImg32 from "../images/arrangeByColumns/LogicWedge5_3_3.png";

import dragImg43 from "../images/arrangeByColumns/LogicWedge5_4_1.png";
import dragImg41 from "../images/arrangeByColumns/LogicWedge5_4_2.png";
import dragImg42 from "../images/arrangeByColumns/LogicWedge5_4_3.png";

import dragImg53 from "../images/arrangeByColumns/LogicWedge5_5_1.png";
import dragImg51 from "../images/arrangeByColumns/LogicWedge5_5_2.png";
import dragImg52 from "../images/arrangeByColumns/LogicWedge5_5_3.png";

import ArrangeByColumns from "./ArrangeByColumns";
import bgNature from '../images/bgNature.png';


const LogicWedge5 = (props) => {
  const [allComplete, setAllComplete] = useState(false);
  const [completedTaskCount, setCompletedTaskCount] = useState(0);

  const chooseTasks = [
    {
      title: 'Active vocabulary',
      columnsItems: [
        {id: 1, successAnswerId: 2, title: "Compound pulley"},
        {id: 2, successAnswerId: 3, title: "Lever"},
        {id: 3, successAnswerId: 1, title: "Wheel"},
      ],
      dragItems: [
        {id: 1, image: dragImg11},
        {id: 2, image: dragImg12},
        {id: 3, image: dragImg13},
      ]
    },
    {
      title: 'Active vocabulary',
      columnsItems: [
        {id: 1, successAnswerId: 3, title: "Movable pulley"},
        {id: 2, successAnswerId: 1, title: "Work"},
        {id: 3, successAnswerId: 2, title: "Screw"},
      ],
      dragItems: [
        {id: 1, image: dragImg23},
        {id: 2, image: dragImg21},
        {id: 3, image: dragImg22},
      ]
    },
    {
      title: 'Active vocabulary',
      columnsItems: [
        {id: 1, successAnswerId: 3, title: "Wheelbarrow"},
        {id: 2, successAnswerId: 1, title: "Seesaw"},
        {id: 3, successAnswerId: 2, title: "Fixed pulley"},
      ],
      dragItems: [
        {id: 1, image: dragImg32},
        {id: 2, image: dragImg33},
        {id: 3, image: dragImg31},
      ]
    },
    {
      title: 'Active vocabulary',
      columnsItems: [
        {id: 1, successAnswerId: 3, title: "Ramp"},
        {id: 2, successAnswerId: 1, title: "Nail"},
        {id: 3, successAnswerId: 2, title: "Fulcrum"},
      ],
      dragItems: [
        {id: 1, image: dragImg43},
        {id: 2, image: dragImg41},
        {id: 3, image: dragImg42},
      ]
    },
    {
      title: 'Active vocabulary',
      columnsItems: [
        {id: 1, successAnswerId: 3, title: "Axis"},
        {id: 2, successAnswerId: 1, title: "Wedge"},
        {id: 3, successAnswerId: 2, title: "Roll"},
      ],
      dragItems: [
        {id: 1, image: dragImg52},
        {id: 2, image: dragImg53},
        {id: 3, image: dragImg51},
      ]
    },
  ]

  return (
    <TaskMainContainer
      lessonCode={props.lessonCode}
      tasksCount={chooseTasks.length}
      completeCount={completedTaskCount}
      setCompletedTaskCount={setCompletedTaskCount}
      taskComplete={allComplete}
    >
      <div className={'logic-wheel-2'}>
        {
          chooseTasks.map((item, i) => (
            <React.Fragment key={`step${i}`}>
              {
                ((completedTaskCount === (i)) || ((i+1) === chooseTasks.length && completedTaskCount >= chooseTasks.length)) ? (
                  <ArrangeByColumns
                    lang={'en'}
                    bgImg={bgNature}
                    title={item.title}
                    columns={item.columnsItems}
                    dragItems={item.dragItems}
                    taskComplete={() => {
                      setCompletedTaskCount(prevState => prevState + 1);
                      if ((i + 1) === chooseTasks.length) {
                        setAllComplete(true);
                      }
                    }}
                  />
                ) : null
              }
            </React.Fragment>
          ))
        }
      </div>
    </TaskMainContainer>
  )
}
export default LogicWedge5;
